import React from "react";
import styles from "./HeroFooter.module.css";
const HeroFooter = () => {
  return (
    <div
      style={{
        background: `url(./assets/HF.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "10% 20%",
      }}
    >
      <div className={styles.container}>
        <p className={styles.animation}>Who we are</p>
        {/* <p className={styles.animation2}>Future of Railways</p> */}
        <div className={styles.section}>
          <h6>
            SPACE.LABS is an Advanced Engineering development studio built on
            the axiom that creative freedom and independence lead to better,
            more innovative railways.
          </h6>
          <h6>
            Spatially Collaborative Engineering (SPACE.LABS) is an engineering
            lab that focuses on developing vision systems for automated
            compliance and predictive maintenance.
          </h6>
        </div>
      </div>
    </div>
  );
};

export default HeroFooter;
